import { useEffect, useState } from 'react';
import { clamp } from '@src/services/timeline';

/**
 * Giữ chuỗi đang gõ trong ô số và chỉ đẩy giá trị ra ngoài khi rời ô hoặc
 * Enter, để người dùng gõ dở không bị ép về giá trị hợp lệ ngay giữa chừng.
 * Trả về sẵn thuộc tính cho <input>, gồm cả phần chặn nhập.
 */
const useNumberDraft = (value, range, onChange) => {
  const [draft, setDraft] = useState(String(value));
  // Dài nhất bằng đúng giá trị lớn nhất của dải, gõ thêm cũng vô ích.
  const maxLength = String(range.MAX).length;

  useEffect(() => setDraft(String(value)), [value]);

  const commit = () => {
    const parsed = Math.round(Number(draft));
    // Ô trống hoặc gõ sai thì quay về giá trị cũ, đừng hiểu thành 0.
    const isValid = draft.trim() !== '' && Number.isFinite(parsed);
    const next = isValid ? clamp(parsed, range.MIN, range.MAX) : value;
    setDraft(String(next));
    if (next !== value) onChange(next);
  };

  return {
    // Dùng text chứ không phải number: input number bỏ qua maxLength và vẫn
    // cho gõ e, dấu cộng trừ, dấu chấm.
    type: 'text',
    inputMode: 'numeric',
    value: draft,
    onChange: (event) =>
      setDraft(event.target.value.replace(/\D/g, '').slice(0, maxLength)),
    onBlur: commit,
    onKeyDown: (event) => event.key === 'Enter' && event.target.blur(),
  };
};

export default useNumberDraft;
